import { render } from "./index.vue?vue&type=template&id=65d18052&scoped=true&bindings={}"
import script from "./Navigation.js?vue&type=script&lang=js"
export * from "./Navigation.js?vue&type=script&lang=js"

import "./Navigation.scss?vue&type=style&index=0&id=65d18052&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65d18052"

export default script